import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { formatPrice } from "utils/formatPrice";

import type { AccessorColumnDef } from "@tanstack/react-table";
import type { ServiceRequestComponent } from "components/ROB/queryKeys";

export const useComponentColumns = () => {
  const { t } = useTranslation();

  return useMemo<AccessorColumnDef<ServiceRequestComponent>[]>(
    () => [
      {
        id: "rob",
        accessorKey: "rob",
        header: () => t("v8_activity", "Activity"),
        cell: ({ row: { original } }) => `${original.rob.code} ${original.rob.description}`
      },
      {
        id: "operation",
        size: 320,
        accessorKey: "operation",
        header: () => t("v8_details", "Details"),
        cell: ({ row: { original } }) => `${original.operation.code} ${original.operation.description}, ${original.reason.code} ${original.reason.description}`
      },
      {
        id: "price",
        size: 120,
        accessorKey: "price",
        header: () => t("v8_amount", "Amount"),
        cell: ({ row: { original } }) => `€ ${formatPrice(original.price)}`
      },
      {
        id: "denialReasons",
        size: 240,
        accessorKey: "denialReasons",
        header: () => t("v8_failure_code", "Failure code"),
        cell: ({ row: { original } }) => original.denialReasons?.map(denialReason => denialReason.code).join(" ")
      },
      {
        id: "status",
        size: 160,
        accessorKey: "status",
        header: () => t("v8_status", "Status"),
        cell: ({ row: { original } }) => original.status.description
      }
    ],
    [t]
  );
};
